import React, { useEffect, useState } from 'react';
import { motion, useScroll, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useCurrency } from '../contexts/CurrencyContext';
import { usePricingPopup } from '../contexts/PricingPopupContext';
export function StickyBuyBar() {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  const {
    formattedPrice
  } = useCurrency();
  const {
    openPopup
  } = usePricingPopup();
  useEffect(() => {
    return scrollY.onChange(latest => {
      setIsVisible(latest > 200);
    });
  }, [scrollY]);
  return <AnimatePresence data-id="element-210">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-[#1e2a4a] border-t border-[#c9a96e]/30 shadow-2xl py-4 px-6" data-id="element-211">
          <div className="max-w-[680px] mx-auto flex items-center justify-between" data-id="element-212">
            <div className="hidden md:block" data-id="element-213">
              <p className="text-[#faf6ef] font-serif font-bold text-lg" data-id="element-214">
                Bedtime Pass Kit
              </p>
              <p className="text-[#c9a96e] text-sm" data-id="element-215">
                {formattedPrice} — Instant Download
              </p>
            </div>

            <button onClick={openPopup} className="flex-1 md:flex-none text-center bg-[#c9a96e] text-[#1e2a4a] font-bold py-3 px-6 rounded-full hover:bg-[#d4b67d] transition-colors flex items-center justify-center gap-2" data-id="element-216">
              Download & print tonight
              <ArrowRight size={18} data-id="element-217" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}